export default {
      id: "icon-gps-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-gps",
      toString: function () {
        return this.url;
      }
    }